export const getTrainingTypeIcon = (type) => {
    switch (type) {
        case "online":
            return "fe fe-smartphone";
        case "offline":
            return "fe fe-home";
        default:
            return "fe fe-book";
    }
};